const e = typeof document < "u" && typeof window < "u";
export {
  e as isBrowser
};
